export const PageHeader = ({ eyebrow, title, description, children }) => (
  <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      {eyebrow && (
        <p className="text-xs uppercase tracking-[0.22em] text-[#00d09c]">{eyebrow}</p>
      )}
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">{title}</h1>
      {description && <p className="mt-2 max-w-2xl text-sm text-[#8f9bb3]">{description}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const StatCard = ({ label, value, accent, testId }) => (
  <div
    data-testid={testId}
    className="rounded-lg border border-[#1e2536] bg-[#10141d] p-5 transition-transform duration-200 hover:-translate-y-1"
  >
    <p className="text-xs uppercase tracking-[0.18em] text-[#4d586f]">{label}</p>
    <p
      className={`font-mono-num mt-3 text-2xl font-semibold ${
        accent === "loss" ? "text-[#ff3b30]" : accent === "profit" ? "text-[#00d09c]" : "text-white"
      }`}
    >
      {value}
    </p>
  </div>
);

export const EmptyState = ({ icon: Icon, title, hint }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
    {Icon && <Icon size={34} className="text-[#2b3550]" />}
    <p className="text-sm text-white">{title}</p>
    {hint && <p className="max-w-sm text-xs text-[#4d586f]">{hint}</p>}
  </div>
);
